<template>
  <main>
    <section class="content-wrapper">
      <div class="tel-service">
      <ag-header title="Meine Anrufe">
        <p><strong>{{totalAmount}}</strong> hinterlassene Nachrichten</p>
      </ag-header>
      <ag-pagination
        :page-count="pageCount"
        :current-page="currentPage"
      />
      <ul class="tel-service__list">
        <li v-if="totalAmount === 0">
          Keine Einträge
        </li>
        <li
          class="tel-service__item"
          v-for="call in calls"
          :key="`call-${call.id}`"
        >
          <telephone-tile
            :headline="call.callerName"
            :id="call.id"
            :date="call.callDatetime"
            :document="call.document"
            :message="call.callerMessage"
            :truncate-long-text="truncateLongText"
            :caller-mail="call.callerMail"
            :caller-phone="call.callerPhone"
            :caller-fax="call.callerFax"
          />
        </li>
      </ul>
      <ag-pagination
        :page-count="pageCount"
        :current-page="currentPage"
      />
  </div>
    </section>
  </main>
</template>

<script>
import TelephoneTile from '@/components/telephone/TelephoneTile.vue';
import AgPagination from '@/components/shared/AgPagination.vue';
import AgHeader from '@/components/shared/AgHeader.vue';

/**
 * @vuese
 *  view component of telephone-service-list route
 */
export default {
  name: 'telehpone-service-list',
  metaInfo: {
    title: 'Telefonservice Eintragsliste',
  },
  components: {
    TelephoneTile,
    AgPagination,
    AgHeader,
  },
  data() {
    return {
      calls: [],
      totalAmount: 0,
      pageCount: 0,
      currentPage: 1,
      pageSize: 10,
      truncateLongText: 0,
    };
  },
  props: {
    /**
     * customerId of logged in user
     */
    customerId: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page || 1, 10);
    if (this.customerId) {
      this.loadCallData();
    } else {
      this.loadCallDataCb = window.setInterval(() => {
        if (this.customerId) {
          this.loadCallData();
          window.clearInterval(this.loadCallDataCb);
        }
      }, 100);
    }
    this.matchMedia = window.matchMedia('(min-width: 1024px)');
    this.matchMedia.addListener(() => this.matchMediaCallback());
    this.matchMediaCallback();
  },
  destroy() {
    window.clearInterval(this.loadCallDataCb);
  },
  methods: {
    loadCallData() {
      this.axios.get(
        `${process.env.VUE_APP_API_ENDPOINT}/customer/${this.customerId}/phone-calls/`, {
          config: {
            showToast: true,
            requestToast: {
              id: `loading-calls-toast-page-${this.currentPage}${this.pageSize}`,
              title: 'Einen Moment bitte…',
              message: '…Ihre Daten werden abgerufen.',
              type: 'loading',
              delay: 133,
            },
          },
          params: {
            page: this.currentPage,
            'page-size': this.pageSize,
          },
        },
      )
        .then(({ headers, data }) => {
          // this.metaInfo.title = `Telefonanruf Übersicht Seite ${this.currentPage}`;
          this.pageSize = parseInt(headers['x-page-size'], 10);
          this.totalAmount = parseInt(headers['x-total-amount'], 10);
          /**
           * emit total amount of calls for parent view
           * @arg {Number} totalAmount
           */
          this.$emit('update-total-amount', this.totalAmount);
          this.pageCount = parseInt(headers['x-page-count'], 10);
          this.calls = data;
        })
        .catch((err) => {
          console.log('Ein Fehler ist passiert', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    matchMediaCallback() {
      if (this.matchMedia.matches) {
        this.truncateLongText = 200;
      } else {
        this.truncateLongText = 76;
      }
    },
  },
  watch: {
    $route(to) {
      this.currentPage = parseInt(to.query.page || 1, 10);
      this.loadCallData();
    },
  },
};
</script>

<style lang="scss">
.tel-service {

  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  &__item {
    margin: em(5px) 0;
  }
}
</style>
